import { computed } from 'vue'
import { QueueSDK, QueueCallSDK } from '@voicenter-team/events-sdk'
import useQueues from '@/composables/useQueues'
import { allRealtimeExtensions } from '@/composables/useStoreExtensions'

const { allQueueCalls, queueWithActiveCalls } = useQueues()

export const sharedAllQueueCalls = computed<QueueCallSDK[]>(
    () => allQueueCalls.value ?? []
)

export const activeCallsQueueMap = computed<Map<number, QueueSDK>>(() => {
    const queues: QueueSDK[] = queueWithActiveCalls.value ?? []
    const map = new Map<number, QueueSDK>()
    for (const queue of queues) {
        map.set(queue.QueueID, queue)
    }
    return map
})

export const answeredCallCountByQueueId = computed<Map<number | string, number>>(() => {
    const map = new Map<number | string, number>()

    for (const extension of allRealtimeExtensions.value) {
        for (const call of extension.calls) {
            if (!call.answered) continue
            const queueId = call.queueID
            map.set(queueId, (map.get(queueId) || 0) + 1)
        }
    }

    return map
})
